/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getMedicines } from 'app/entities/medicine/medicine.reducer';
import { getEntities as getFrequencies } from 'app/entities/frequency/frequency.reducer';
import { getEntities as getSequences } from 'app/entities/sequence/sequence.reducer';
import { getEntities as getDosageGuidelines } from 'app/entities/dosage-guideline/dosage-guideline.reducer';
import { getEntities as getRegimenCycles } from 'app/entities/regimen-cycle/regimen-cycle.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { createEntity, getEntity, reset, updateEntity } from './regimen-drug.reducer';

export const RegimenDrugUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const medicines = useAppSelector(state => state.medicine.entities);
  const frequencies = useAppSelector(state => state.frequency.entities);
  const sequences = useAppSelector(state => state.sequence.entities);
  const dosageGuidelines = useAppSelector(state => state.dosageGuideline.entities);
  const regimenCycles = useAppSelector(state => state.regimenCycle.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const regimenDrugEntity = useAppSelector(state => state.regimenDrug.entity);
  const loading = useAppSelector(state => state.regimenDrug.loading);
  const updating = useAppSelector(state => state.regimenDrug.updating);
  const updateSuccess = useAppSelector(state => state.regimenDrug.updateSuccess);

  const handleClose = () => {
    navigate(`/regimen-drug${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getMedicines({}));
    dispatch(getFrequencies({}));
    dispatch(getSequences({}));
    dispatch(getDosageGuidelines({}));
    dispatch(getRegimenCycles({}));
    dispatch(getClinicalDictionaries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...regimenDrugEntity,
      ...values,
      drug: medicines.find(it => it.id.toString() === values.drug?.toString()),
      frequency: frequencies.find(it => it.id.toString() === values.frequency?.toString()),
      sequence: sequences.find(it => it.id.toString() === values.sequence?.toString()),
      dose: dosageGuidelines.find(it => it.id.toString() === values.dose?.toString()),
      cycle: regimenCycles.find(it => it.id.toString() === values.cycle?.toString()),
      medicationType: clinicalDictionaries.find(it => it.id.toString() === values.medicationType?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...regimenDrugEntity,
          drug: regimenDrugEntity?.drug?.id,
          frequency: regimenDrugEntity?.frequency?.id,
          sequence: regimenDrugEntity?.sequence?.id,
          dose: regimenDrugEntity?.dose?.id,
          cycle: regimenDrugEntity?.cycle?.id,
          medicationType: regimenDrugEntity?.medicationType?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.regimenDrug.home.createOrEditLabel" data-cy="RegimenDrugCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.regimenDrug.home.createOrEditLabel">Create or edit a RegimenDrug</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="regimen-drug-id"
                  label={translate('tinyMedicRestApp.regimenDrug.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenDrug.drugClass')}
                id="regimen-drug-drugClass"
                name="drugClass"
                data-cy="drugClass"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenDrug.active')}
                id="regimen-drug-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenDrug.cursor')}
                id="regimen-drug-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenDrug.lastUpdated')}
                id="regimen-drug-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenDrug.microSec')}
                id="regimen-drug-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenDrug.timestampEntry')}
                id="regimen-drug-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="regimen-drug-drug"
                name="drug"
                data-cy="drug"
                label={translate('tinyMedicRestApp.regimenDrug.drug')}
                type="select"
              >
                <option value="" key="0" />
                {medicines
                  ? medicines.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="regimen-drug-frequency"
                name="frequency"
                data-cy="frequency"
                label={translate('tinyMedicRestApp.regimenDrug.frequency')}
                type="select"
              >
                <option value="" key="0" />
                {frequencies
                  ? frequencies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="regimen-drug-sequence"
                name="sequence"
                data-cy="sequence"
                label={translate('tinyMedicRestApp.regimenDrug.sequence')}
                type="select"
              >
                <option value="" key="0" />
                {sequences
                  ? sequences.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="regimen-drug-dose"
                name="dose"
                data-cy="dose"
                label={translate('tinyMedicRestApp.regimenDrug.dose')}
                type="select"
              >
                <option value="" key="0" />
                {dosageGuidelines
                  ? dosageGuidelines.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="regimen-drug-cycle"
                name="cycle"
                data-cy="cycle"
                label={translate('tinyMedicRestApp.regimenDrug.cycle')}
                type="select"
              >
                <option value="" key="0" />
                {regimenCycles
                  ? regimenCycles.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="regimen-drug-medicationType"
                name="medicationType"
                data-cy="medicationType"
                label={translate('tinyMedicRestApp.regimenDrug.medicationType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/regimen-drug" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RegimenDrugUpdate;
